<template>
    <v-container fluid>
        <cpPageTitle title="Sezione Zone">
            <template v-slot:actions v-if="$permission($auth.utente.role.name, 'editZone')">
                <router-link to="/zone/new" class="text-decoration-none">
                    <v-btn color="success" :icon="!$vuetify.breakpoint.mdAndUp" :rounded="$vuetify.breakpoint.mdAndUp" :large="$vuetify.breakpoint.mdAndUp">
                        <v-icon :class="{ 'pr-2': $vuetify.breakpoint.mdAndUp }">add_circle</v-icon>
                        <span class="d-none d-md-inline">Crea Zona</span>
                    </v-btn>
                </router-link>

                <v-btn
                    color="success"
                    :icon="!$vuetify.breakpoint.mdAndUp"
                    :rounded="$vuetify.breakpoint.mdAndUp"
                    :large="$vuetify.breakpoint.mdAndUp"
                    @click="modalFilter = !modalFilter"
                >
                    <v-icon :class="{ 'pr-2': $vuetify.breakpoint.mdAndUp }">filter_alt</v-icon>
                    <span class="d-none d-md-inline">Filtri</span>
                </v-btn>

                <div class="text-center">
                    <v-bottom-sheet v-model="modalFilter">
                        <v-sheet class="text-center" height="250px">
                            <!-------------- reset filter ----------------->
                            <v-container cols="12">
                                <v-row class="d-flex justify-center">
                                    <!-- Close button -->
                                    <v-col cols="3" class="d-flex justify-center" @click="modalFilter = !modalFilter">
                                        <v-btn class="mt-n8 d-none d-sm-flex" color="error">Chiudi</v-btn>
                                        <v-btn color="error" class="d-flex d-sm-none icon"><v-icon> cancel </v-icon></v-btn>
                                    </v-col>

                                    <!-- Reset filters button -->
                                    <v-col cols="6">
                                        <v-btn class="mt-n8" color="warning" @click="clearFilters">Reset filtri</v-btn>

                                        <h1 class="mt-4">Filtri</h1>
                                    </v-col>

                                    <!-- Apply button -->
                                    <v-col cols="3" class="d-flex justify-center" @click="setFilter()">
                                        <v-btn class="mt-n8 d-none d-sm-flex" color="success">Applica</v-btn>
                                        <v-btn color="success" class="d-flex d-sm-none icon"> <v-icon> search </v-icon></v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>

                            <div class="pa-6">
                                <v-col cols="12"> </v-col>
                                <v-row>
                                    <v-col cols="12 " sm="12">
                                        <v-autocomplete
                                            label="Assegnato ad agente"
                                            item-text="name"
                                            :search-input.sync="searchUser"
                                            cache-items
                                            multiple
                                            hide-no-data
                                            v-model="selectUser"
                                            :loading="loadingUser"
                                            :items="User"
                                            return-object
                                            solo-inverted
                                            flat
                                            chips
                                            deletable-chips
                                            clearable
                                        ></v-autocomplete>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>

            <v-text-field v-model="search" class="mt-0 pt-0" append-icon="search" label="Ricerca nome" single-line hide-details clearable></v-text-field>
        </cpPageTitle>
        <!------------- GRIGLIE ----------------->
        <v-card class="marginScroll">
            <v-data-table
                :headers="headers"
                :items="zones"
                :options.sync="options"
                :server-items-length="totalZones"
                :loading="loading"
                :search="search"
                class="pt-6 elevation-6"
                :footer-props="{ itemsPerPageOptions: [10, 30, 50, 100] }"
                v-model="selectedZones"
                @update:options="updateUrl"
                :mobile-breakpoint="1270"
            >
                <!-- pulsante azioni -->

                <template v-slot:top v-if="$permission($auth.utente.role.name, 'deleteZone')">
                    <v-menu transition="slide-y-transition" bottom v-if="selectedZones.length" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" class="ml-6 mt-n2 mb-4" v-bind="attrs" v-on="on"> Azioni </v-btn>
                        </template>
                        <v-list class="text-uppercase">
                            <v-list-item @click="showDeleteDialogSelect">
                                <v-list-item-title class="ma-4"><v-icon color="black" class="mb-1" left> delete </v-icon> Elimina </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
                <!------------- azione ----------------->

                <template #[`item.id`]="{ value }">
                    <v-container class="d-flex flex-row mr-n2" :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'" flat tile>
                        <router-link :to="`/zone/${value}/edit`">
                            <v-icon>edit</v-icon>
                        </router-link>
                        <router-link :to="`/zone/${value}`">
                            <v-icon class="pr-3 pl-3">visibility</v-icon>
                        </router-link>
                        <v-icon @click="showDeleteDialog(value)" v-if="$permission($auth.utente.role.name, 'deleteZone')">cancel</v-icon>
                    </v-container>
                </template>

                <!-- Aggiunta colonna "Assegnato ad agente" -->
                <template #[`item.agents`]="{ value }">
                    <v-list-item-content>
                        <v-list-item-title>
                            <template v-if="value.length > 0">
                                <template v-if="value.length <= 2">
                                    {{ value.join(', ') }}
                                </template>
                                <template v-else>
                                    <v-btn color="primary" @click="showAllAgents(value)"> Guarda tutto </v-btn>
                                </template>
                            </template>
                            <template v-else> - </template>
                        </v-list-item-title>
                    </v-list-item-content>
                </template>
            </v-data-table>
            <v-dialog v-model="showAllAgentsDialog" max-width="500">
                <v-card>
                    <v-card-title class="headline justify-center">Agenti assegnati</v-card-title>
                    <v-card-text>
                        <v-list>
                            <v-list-item v-for="agent in allAgents" :key="agent.id">
                                <v-list-item-content>
                                    <v-list-item-title>{{ agent }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" @click="showAllAgentsDialog = false">Chiudi</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
        <v-dialog v-model="showDeleteConfirmation" max-width="500">
            <v-card outlined>
                <v-card-title class="text-h5 grey justify-center lighten-2"> Confermi </v-card-title>

                <v-card-text class="mt-6, text-center mt-6"> Sei sicuro di voler eliminare la zona? </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn text @click="cancelDelete">Annulla</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="red" text @click="deleteZ(deleteDialogCall)">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import cpPageTitle from '@/components/cpPageTitle.vue'

export default {
    name: 'Zones',
    components: { cpPageTitle },
    data() {
        return {
            zones: [],
            totalZones: 0,
            loading: true,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
                groupBy: [],
                groupDesc: [],
                multiSort: null,
                mustSort: null
            },
            search: '',
            timeoutQuery: null,
            showAllAgentsDialog: false,
            showDeleteConfirmation: false,
            deleteDialogMsg: '',
            deleteDialogCall: null,
            allAgents: [],
            headers: [
                { text: 'Nome zona', value: 'name', field: 'Name' },
                {
                    text: 'Numero leads',
                    value: 'leads',
                    field: 'leads',
                    sortable: false
                },
                { text: 'Categoria', value: 'selectCategory' }
            ],
            zoneToDelete: null,
            modalFilter: false,
            searchUser: null,
            selectUser: [],
            loadingUser: false,
            User: [],
            selectedZones: [],
            changinurl: false
        }
    },
    watch: {
        search: {
            handler() {
                if (!this.search || this.search.length == 0) {
                    this.setFilter()
                    return
                }
                if (this.search.length < 3) {
                    return
                }
                if (this.timeoutQuery) {
                    clearTimeout(this.timeoutQuery)
                }
                this.timeoutQuery = setTimeout(() => {
                    this.setFilter()
                }, 300)
            }
        },
        searchUser(val) {
            val && this.getUser(val)
        }
    },
    async created() {
        if (!this.$permission(this.$auth.utente.role.name, 'ZonePage')) {
            this.$router.push('/')
        }
        this.changinurl = true
        if (this.$route.query.page) {
            this.options.page = parseInt(this.$route.query.page)
        }
        if (this.$route.query.items) {
            this.options.itemsPerPage = parseInt(this.$route.query.items)
        }
        if (this.$route.query.sortBy) {
            this.options.sortBy[0] = this.$route.query.sortBy
            if (this.$route.query.sortDesc) {
                this.options.sortDesc[0] = this.$route.query.sortDesc
            }
        }
        if (this.$route.query.search) {
            this.search = decodeURIComponent(this.$route.query.search)
        }

        if (this.$route.query.agente) {
            await this.getUserFromApiId(this.$route.query.agente)
        }

        //this.getDataFromApi()
        if (this.$permission(this.$auth.utente.role.name, 'editZone')) {
            this.headers = [
                {
                    text: 'Azione',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                    field: 'id'
                },
                ...this.headers,
                {
                    text: 'Assegnato ad agente',
                    value: 'agents',
                    field: 'agents.Name'
                }
            ]
            if (this.$route.query.agente) {
                await this.getAgentsFromApiId(this.$route.query.agente)
            }
        }
        this.changinurl = false
    },
    methods: {
        clearFilters() {
            // Reset all filter
            this.selectUser = []
        },
        updateUrl() {
            if (this.changinurl) return

            let query = { ...this.$route.query }
            this.changinurl = true
            if (this.options.page > 1) {
                if (this.$route.query.page != this.options.page) {
                    query.page = this.options.page
                }
            } else {
                delete query.page
            }
            if (this.options.itemsPerPage > 10) {
                if (this.$route.query.items != this.options.itemsPerPage) {
                    query.items = this.options.itemsPerPage
                }
            } else {
                delete query.items
            }
            if (this.options.sortBy.length) {
                if (this.$route.query.sortBy != this.options.sortBy) {
                    query.sortBy = this.options.sortBy
                    if (this.options.sortDesc.length && this.$route.query.sortDesc != this.options.sortDesc) {
                        query.sortDesc = this.options.sortDesc
                    }
                }
            } else {
                delete query.sortBy
                delete query.sortDesc
            }
            if (this.search) {
                if (this.$route.query.search != this.search) {
                    query.search = encodeURIComponent(this.search)
                }
            } else {
                delete query.search
            }

            if (this.selectUser.length) {
                if (this.$route.query.agente != this.selectUser.map((x) => x.id).join(',')) {
                    query.agente = this.selectUser.map((x) => x.id).join(',')
                }
            } else {
                delete query.agente
            }

            this.$router
                .replace({
                    path: this.$route.path,
                    query: query
                })
                .catch((err) => {})
            this.getDataFromApi()
            this.changinurl = false
        },
        getUser(val) {
            if (val.length < 2) {
                return
            }
            if (this.timeoutQuery) {
                clearTimeout(this.timeoutQuery)
            }
            this.timeoutQuery = setTimeout(() => this.getUserFromApi(val), 300)
        },
        async getUserFromApi(val) {
            this.loadingUser = true
            const p = await this.$http.get(`agents`, { 'pagination[pageSize]': 200, 'filters': { Name: { $containsi: val } } })
            if (!p.data.length) {
                this.loadingUser = false
                return
            }
            this.User = p.data.map((x) => {
                return { id: x.id, name: x.attributes.Name }
            })
            this.loadingUser = false
        },
        async getUserFromApiId(val) {
            this.loadingUser = true
            let filters = {}
            let c = 0
            val.split(',').forEach((x) => {
                filters[`filters[$or][${c}][id][$eq]`] = x
                c++
            })
            let ci = []
            let cc = {}
            let pa = 1
            do {
                cc = await this.$http.get(`agents`, {
                    'pagination[pageSize]': 200,
                    'pagination[page]': pa,
                    ...filters
                })
                ci = ci.concat(cc.data)
                pa++
            } while (cc.meta.pagination.pageCount > cc.meta.pagination.page)
            if (!cc.data.length) {
                this.loadingUser = false
                return
            }
            this.User = ci.map((x) => {
                return { id: x.id, name: x.attributes.Name }
            })
            this.selectUser = ci.map((x) => {
                return { id: x.id, name: x.attributes.Name }
            })

            this.loadingUser = false
        },
        setFilter() {
            this.options.page = 1
            this.updateUrl()
            this.modalFilter = false
        },
        showDeleteDialog(zoneId) {
            this.zoneToDelete = zoneId
            this.deleteDialogMsg = 'Sei sicuro di voler eliminare la zona?'
            this.deleteDialogCall = true
            this.showDeleteConfirmation = true
        },
        showDeleteDialogSelect() {
            this.deleteDialogMsg = 'Sei sicuro di voler eliminare le zone selezionate?'
            this.deleteDialogCall = false
            this.showDeleteConfirmation = true
        },
        deleteZ(type = false) {
            if (type) {
                this.deleteZone()
            } else {
                this.deleteSelect()
            }
        },
        async deleteZone() {
            try {
                // Effettua la chiamata HTTP per eliminare il lead
                await this.$http.delete(`zones/${this.zoneToDelete}`)

                // Eliminazione riuscita, esegui le azioni necessarie
                // ...

                // Aggiorna i dati dopo l'eliminazione
                await this.getDataFromApi()

                // Chiudi il dialogo di conferma ed esegui altre azioni
                this.showDeleteConfirmation = false
                this.zoneToDelete = null
            } catch (error) {
                // Gestisci l'errore durante l'eliminazione del lead
                console.error(error)

                // Mostra una notifica di errore
                this.$notify({
                    group: 'notifica',
                    title: 'Errore',
                    text: "Si è verificato un errore durante l'eliminazione della zona",
                    type: 'error'
                })

                // Chiudi il dialogo di conferma ed esegui altre azioni
                this.showDeleteConfirmation = false
                this.zoneToDelete = null
            }
        },

        cancelDelete() {
            this.showDeleteConfirmation = false
            this.leadToDelete = null
            this.deleteDialogMsg = ''
            this.deleteDialogCall = false
        },
        async getCategories(zoneId) {
            try {
                const response = await this.$http.get(`zones/${zoneId}`, {
                    populate: ['selectedCategories']
                })

                // Estrai le categorie dalla risposta
                const selectedCategories = response.data.attributes.selectedCategories || []
                return selectedCategories.join(', ')
            } catch (error) {
                console.error('Errore nel recupero delle categorie:', error)
                return '-'
            }
        },
        async getDataFromApi() {
            // Imposta loading state
            this.loading = true

            try {
                // Destrutturazione delle opzioni di paginazione e ordinamento
                const { sortBy, sortDesc, page, itemsPerPage } = this.options
                let filters = {}

                // Costruzione dei filtri
                let cc = 0

                // Filtro per la ricerca
                if (this.search) {
                    filters[`filters[$and][${cc}][Name][$containsi]`] = this.search
                    cc++
                }

                // Filtro per gli utenti selezionati
                if (this.selectUser) {
                    let c = 0
                    this.selectUser.forEach((x) => {
                        filters[`filters[$and][${cc}][$or][${c}][agents][id][$eq]`] = x.id
                        c++
                    })
                    cc++
                }

                // Filtro per i permessi
                if (this.$permission(this.$auth.utente.role.name, 'groupLeadTable')) {
                    if (!this.$auth.utente.agent.zones.length) {
                        this.loading = false
                        return
                    }
                    let c = 0
                    this.$auth.utente.agent.zones.forEach((x) => {
                        filters[`filters[$and][${cc}][$or][${c}][id][$eq]`] = x.id
                        c++
                    })
                    cc++
                }

                // Gestione dell'ordinamento
                let sort = 'Name'
                if (sortBy.length) {
                    const el = this.headers.find((x) => x.value == sortBy[0])
                    sort = el.field.concat(sortDesc[0] ? ':desc' : '')
                }

                // Singola chiamata API che include tutti i dati necessari
                const docs = await this.$http.get('zonelist', {
                    pageSize: itemsPerPage,
                    page: page,
                    populate: ['leads', 'leads.parent_lead', 'agents'],
                    sort: sort,
                    ...filters
                })

                // Assegnazione diretta dei risultati
                this.zones = docs.results || docs
                this.totalZones = docs.pagination.total ? docs.pagination.total : 0
            } catch (error) {
                console.error('Errore nel caricamento delle zone:', error)
                this.$notify({
                    group: 'notifica',
                    title: 'Errore',
                    text: 'Errore nel caricamento delle zone',
                    type: 'error'
                })
            } finally {
                this.loading = false
            }
        },
        formatCategories(categories) {
            if (!categories || categories.length === 0) return '-'
            return categories.join(', ')
        },
        showAllAgents(agents) {
            this.allAgents = agents
            this.showAllAgentsDialog = true
        },
        async deleteSelect() {
            if (!this.$permission(this.$auth.utente.role.name, 'deleteZone')) {
                return
            }
            try {
                for (const zona of this.selectedZones) {
                    await this.$http.delete(`zones/${zona.id}`)
                }

                this.getDataFromApi()
                this.selectedZones = []
                this.cancelDelete()
                this.$notify({
                    group: 'notifica',
                    title: 'Successo',
                    text: 'Zone selezionate cancellate con successo',
                    type: 'success'
                })
            } catch (error) {
                console.error(error)
                this.cancelDelete()
                this.$notify({
                    group: 'notifica',
                    title: 'Errore',
                    text: "Si è verificato un errore durante l'eliminazione delle zone selezionate",
                    type: 'error'
                })
            }
        }
    }
}
</script>
